import React, { Component } from "react";
import PropTypes from "prop-types";
import styles from "../translations/Translation.module.scss";
import ClearIcon from "@mui/icons-material/Clear";
import DoneIcon from "@mui/icons-material/Done";
import { Grid } from "@mui/material";
import EMPInputField from "../../shared/components/EMPInputField/EMPInputField";

class AddNewTranslation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDiv: true,
      newtrans: {
        moduleKey: "",
        key: "",
        en: "",
        de: "",
        fr: "",
        nl: "",
        no: "",
        es: "",
        it: "",
        fi: "",
        da: "",
      },
      key: "",
      en: "",
      translatedValue: "",
    };

    this.lan = this.props.localizedInfo.defaultLanguage.isocode.slice(0, 2);
  }

  handleChangeKey = (event) => {
    this.setState({ key: event.target.value });
  };

  handleChangeEn = (event) => {
    this.setState({ en: event.target.value });
  };

  handleChangeTranslatedValue = (event) => {
    this.setState({ translatedValue: event.target.value });
  };

  cancelTranslation = () => {
    this.setState({ showDiv: false });
    this.props.cancelSpecificTranslation();
  };

  addTranslation = () => {
    this.setState({ showDiv: false });

    const updatedLanguage = { ...this.state.newtrans };

    updatedLanguage.en = this.state.en;
    updatedLanguage.de = this.state.en;
    updatedLanguage.fr = this.state.en;
    updatedLanguage.nl = this.state.en;
    updatedLanguage.no = this.state.en;
    updatedLanguage.it = this.state.en;
    updatedLanguage.es = this.state.en;
    updatedLanguage.fi = this.state.en;
    updatedLanguage.da = this.state.en;

    updatedLanguage[this.lan] = this.state.translatedValue;
    updatedLanguage.key = this.state.key;
    updatedLanguage.moduleKey = this.props.moduleKey;

    this.props.addSpecificTranslation(updatedLanguage);
  };

  render() {
    return (
      <div>
        {this.state.showDiv && (
          <Grid container className={styles.translation_header}>
            <Grid item md={3}>
              <div style={{ width: "95%" }}>
                <EMPInputField
                  type="text"
                  name="topicBox"
                  placeholder={this.props.t("Translations.enterKey")}
                  onChange={this.handleChangeKey}
                />
              </div>
            </Grid>

            <Grid item md={3}>
              <div style={{ width: "95%" }}>
                <EMPInputField
                  type="text"
                  name="topicBox"
                  placeholder={this.props.t("Translations.enterEng")}
                  onChange={this.handleChangeEn}
                />
              </div>
            </Grid>

            <Grid item md={3}>
              <div style={{ width: "95%" }}>
                <EMPInputField
                  type="text"
                  name="topicBox"
                  placeholder={this.props.t("Translations.enterLan")}
                  onChange={this.handleChangeTranslatedValue}
                />
              </div>
            </Grid>

            <div className={styles.lanUpdate}>
              <DoneIcon
                fontSize="small"
                style={{ color: "green" }}
                className={styles.button_hover}
                onClick={this.addTranslation}
              />
              <ClearIcon
                fontSize="small"
                color="secondary"
                className={styles.button_hover}
                onClick={this.cancelTranslation}
              />
            </div>
          </Grid>
        )}
      </div>
    );
  }
}

AddNewTranslation.propTypes = {
  addSpecificTranslation: PropTypes.func.isRequired,
  cancelSpecificTranslation: PropTypes.func.isRequired,
  localizedInfo: PropTypes.shape({
    defaultLanguage: PropTypes.shape({
      isocode: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  moduleKey: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

export default AddNewTranslation;
